module.exports = __webpack_public_path__ + "img/portada 1.ac78024b.png";